import * as types from 'constants/actionTypes'

const initialState = {
  isEditorPopoverVisible: false,
}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.CHANGE_EDITOR_POPOVER_VISIBILITY:
      return { ...state, isEditorPopoverVisible: action.value }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/gui.js